import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  FieldWrappers,
  ModalHeader,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";

const documentSchema = Yup.object().shape({
  name: Yup.string()
    .required("Title is required")
    .min(3, "Title must be at least 3 characters"),
});

const CreateFolder = ({
  handleClose,
  createFolderMutate,
  isCreateLoading,
  currentPath,
}) => {
  const initialDocumentValues = {
    name: "",
  };
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDocumentSubmit = (values) => {
    const body = {
      name: values.name,
      parentFolderId:
        currentPath.length > 0
          ? Number(currentPath[currentPath.length - 1].id)
          : undefined,
    };

    createFolderMutate(body);
  };

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <Title>Create Folder</Title>

        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>
      <div className="px-6 h-full flex flex-col justify-between">
        <Formik
          initialValues={initialDocumentValues}
          onSubmit={handleDocumentSubmit}
          validationSchema={documentSchema}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form className="flex flex-col h-full">
              <ScrollableContent className="flex-1">
                <Wrapper>
                  <InputGroup>
                    <Label htmlFor="name">Folder Name *</Label>
                    <FieldWrappers>
                      <Field
                        type="text"
                        name="name"
                        id="name"
                        autoComplete="off"
                        // required
                        placeholder="Enter folder name"
                      />
                    </FieldWrappers>
                    {errors.name && touched.name && (
                      <ErrorMessage>{errors.name}</ErrorMessage>
                    )}
                  </InputGroup>
                </Wrapper>
              </ScrollableContent>
              <ActionSection>
                <SideCancelBtn
                  type="button"
                  onClick={handleClose}
                  disabled={isCreateLoading}
                >
                  Cancel
                </SideCancelBtn>
                <SubmitBtn type="submit" disabled={isCreateLoading}>
                  {isCreateLoading ? "Creating..." : "Create"}
                </SubmitBtn>
              </ActionSection>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const Title = tw.h1`text-white text-lg font-medium`;

export default CreateFolder;
